/**
 * Copyright 2021 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useLegacyRouter } from '@/hooks/useLegacyRouter';
import { useRouter } from 'next/navigation';
import { parseUrl, stringifyUrl } from '../utils/urlHelpers';

const useRemoveAppliedPriceFilters = (): ((onRemoveFilter?: () => void) => void) => {
  const legacyRouter = useLegacyRouter();
  const router = useRouter();

  const removeAppliedPriceFilters = (onRemoveFilter?: () => void) => {
    const { asPath } = legacyRouter;
    const { url, query } = parseUrl(asPath);
    let tempUrl = url;
    delete query.maxPrice;
    delete query.minPrice;
    tempUrl = stringifyUrl(
      {
        url: tempUrl,
        query: {
          ...query,
          seourl: null,
          seoUrlPath: null,
          pageNumber: null,
          currentPage: null,
        },
      },
      {
        skipNull: true,
      },
    );
    onRemoveFilter?.();
    void router.push(tempUrl);
  };

  return removeAppliedPriceFilters;
};

export { useRemoveAppliedPriceFilters };
